import {Input} from 'antd'
import React from 'react'

const DecoratedInputField = ({ label, ...props }) => (
    <div className="flex flex-col px-3 py-2 border background rounded-xl hover:shadow-sm">
        <div className="text-xs text-gray-500 tracking-wider">
            {label}
        </div>
        <Input {...props} />
    </div>
)

export default DecoratedInputField
